export const PLATFORM_PATH = 'platform';
export const PLATFORM_BASE = `/${PLATFORM_PATH}`;
